import { ProcessTypeConfigModel } from "../../models/processTypeConfigModel";

export function setIsConstructionActivityMandatory(config: ProcessTypeConfigModel) {
    let elemId = $('#process-is-construction-activity-required-field-id').data('value');
    let element: JQuery = $(`label[for=${elemId}]`);

    element.next().remove();

    if (config.IsConstructionActivityRequired) {
        element.parent().append('<sup class="required">*</sup>')
    }
}
